import { Injectable } from '@angular/core';
import {HttpClient, HttpEvent, HttpErrorResponse, HttpEventType} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from "../../environments/environment";
import { HttpHeaders } from '@angular/common/http';


@Injectable({ providedIn: 'root' })
export class UserService {
    backendUrl: string = environment.apiUrl;
    url_final: string;
    constructor(private http: HttpClient) { }

    getAll() {
        return this.http.get<any[]>('${config.apiUrl}/users');
    }

    register(correo, empresa, password,telefono,nombre_usuario) {
      this.url_final = this.backendUrl + "/rmsfe/registrar_cuenta"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, { correo, empresa, password,telefono,nombre_usuario})
      .pipe(map(response => {
        // console.log("la api es");
        // console.log(response)
        return response;
      }));
    }

    delete(id) {
        return this.http.delete('${config.apiUrl}/users/${id}');
    }

    //Se agregaran nuevas funsiones para guardado 
    registrarUserFromCuenta(data){
      this.url_final = this.backendUrl + "/rmsfe/registrar_nuevo_usuario"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {data})
      .pipe(map(response => {
        return response;
      }));
    }
    actualizarUserFront(data){ 
      this.url_final = this.backendUrl + "/rmsfe/editar_user_front"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {data})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarUserFront(user_id){
      this.url_final = this.backendUrl + "/rmsfe/get_user_front_api?user_id="
      this.url_final = `${this.url_final}${user_id}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }
    
    eliminaruser(user_id){
      this.url_final = this.backendUrl + "/rmsfe/desactivar_user_front_api"
      this.url_final = `${this.url_final}`;
  
      var fd = new FormData();
      fd.append('user_id', user_id);
  
      return this.http.post<any>(this.url_final, fd)
      .pipe(map(response => {
        return response;
      }));
  
    }

    //!bloque para las acciones y creaciones de roles y permisos
    actualizarRole(data){ 
      this.url_final = this.backendUrl + "/rmsfe/editar_role"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {data})
      .pipe(map(response => {
        return response;
      }));
    }
    registrarRole(data){
      this.url_final = this.backendUrl + "/rmsfe/crear_role"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {data})
      .pipe(map(response => {
        return response;
      }));
    }

    consultarRoles(role_id){
      this.url_final = this.backendUrl + "/rmsfe/get_role_seller?role_id="
      this.url_final = `${this.url_final}${role_id}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }
    getRolesSeller(){
      this.url_final = this.backendUrl + "/rmsfe/get_tab_role_seller"
      this.url_final = `${this.url_final}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    consultar_permisos(role_id){
      this.url_final = this.backendUrl + "/rmsfe/get_permisos_role?role_id="
      this.url_final = `${this.url_final}${role_id}`;
      return this.http.get<any>(this.url_final,  {observe: 'response'})
      .pipe(map(response => {
        return response;
      }));
    }

    registrar_permisos(data){
      this.url_final = this.backendUrl + "/rmsfe/guardar_permisos"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {data})
      .pipe(map(response => {
        return response;
      }));
    }
    eliminarRole(role_id){
      this.url_final = this.backendUrl + "/rmsfe/eliminar_role"
      this.url_final = `${this.url_final}`;
  
      var fd = new FormData();
      fd.append('role_id', role_id);
  
      return this.http.post<any>(this.url_final, fd)
      .pipe(map(response => {
        return response;
      }));
  
    }
    cambiar_idioma_user(data){
      this.url_final = this.backendUrl + "/rmsfe/cambiar_idioma_user"
      this.url_final = `${this.url_final}`;
      return this.http.post<any>(this.url_final, {data})
      .pipe(map(response => {
        return response;
      }));
    }

}